import { configureStore } from "@reduxjs/toolkit";
import gameSlice from "./features/gameSlice";
import accountSlice from "./features/accountSlice";
export const saveState = (state) => {
  try {
    const accountState = {
      account: state.account,
    };
    const serializedState = JSON.stringify(accountState);
    localStorage.setItem("state", serializedState);
  } catch (err) {
  }
};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

const persistedState = loadState();
const store = configureStore({
  reducer: {
    gameData: gameSlice,
    account: accountSlice,
  },
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Persist account state to localStorage whenever it changes
// so reload always has the freshest token/user data.
let lastAccount = store.getState().account;
store.subscribe(() => {
  const currentAccount = store.getState().account;
  if (currentAccount !== lastAccount) {
    lastAccount = currentAccount;
    saveState(store.getState());
  }
});

export default store;
